module.exports = __webpack_public_path__ + "static/media/bckimg.c42f23cb.png";